import { render, staticRenderFns } from "./ModalTemplate.vue?vue&type=template&id=66f5bf42&scoped=true&"
import script from "./ModalTemplate.vue?vue&type=script&lang=js&"
export * from "./ModalTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ModalTemplate.vue?vue&type=style&index=0&id=66f5bf42&lang=scss&scoped=true&"
import style1 from "./ModalTemplate.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f5bf42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/development/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66f5bf42')) {
      api.createRecord('66f5bf42', component.options)
    } else {
      api.reload('66f5bf42', component.options)
    }
    module.hot.accept("./ModalTemplate.vue?vue&type=template&id=66f5bf42&scoped=true&", function () {
      api.rerender('66f5bf42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/ModalTemplate.vue"
export default component.exports